
  <div class="l-cards">
    <div *ngIf="!listProducts.length">Desculpe, não encontramos nada!</div>
    <a *ngFor="let product of listProducts" class="m-1 text-decoration-none" style="cursor: pointer;" routerLink="/produto-detalhe/{{product.slug ? product.slug : product.codPro }}">
      <div style="position: absolute;">
        <div *ngIf="product.novo && !product.fora_de_linha" class="circle bg-light-blue">NOVO</div>
        <div *ngIf="!product.novo && !product.fora_de_linha && product.mais_vendido" class="circle bg-main-yellow best-seller">
          <span class="plus">+</span>
          <span class="seller">VENDIDO</span>
        </div>
      </div>
        <div class="border p-3 d-flex justify-content-center align-itens-center align-self-start card-product" >
          <div *ngIf="!product.resizedImageUrl" style="width: 100%; height: auto;" ></div>
          <img *ngIf="product.resizedImageUrl"  style="width: 100%; height: auto; object-fit: contain;" [ngClass]="{'opacity-25':product.fora_de_linha}" src="{{product.resizedImageUrl}}" alt="">
        </div>
        <div class="title-products-cards">
          <p style="word-wrap: break-word; text-transform: uppercase;"><span class="esconder-prioridade">{{product.prioridade}} - </span> {{product.nome ? product.nome : product.desPro}}</p>
          <p class="card-cod-pro-home">Ref: {{product.codPro}}
            <span *ngIf="product.fora_de_linha" class="text-uppercase">
              <br>
              Indisponível
            </span>
          </p>

        </div>
    </a>
  </div>

